import React from "react";
import { Box, Button, Typography, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CheckCircle } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import SignupStepper from "../../components/SignupStepper";

const PageContainer = styled(Box)(() => ({
	position: "relative",
	minHeight: "100vh",
	background:
		"linear-gradient(135deg, #E8F5F5 0%, #FFFFFF 50%, #E8F5F5 100%)",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	padding: 0,
}));

const Card = styled(Paper)(() => ({
	width: "100%",
	minHeight: "100vh",
	background: "rgba(255, 255, 255, 0.95)",
	borderRadius: 0,
	boxShadow: "none",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	paddingTop: 24,
}));

const SuccessIconWrap = styled(Box)(() => ({
	width: 140,
	height: 140,
	borderRadius: "50%",
	background: "#1E7A1E",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	margin: "120px auto 32px",
	boxShadow: "0 12px 32px rgba(30, 122, 30, 0.25)",
}));

const PrimaryButton = styled(Button)(() => ({
	background: "linear-gradient(135deg, #5DBEC3 0%, #4BA3A7 100%)",
	color: "#ffffff",
	fontWeight: 600,
	fontSize: "16px",
	textTransform: "none",
	borderRadius: 8,
	padding: "16px 32px",
	width: "100%",
	maxWidth: 480,
	boxShadow: "0 4px 15px rgba(93, 190, 195, 0.3)",
	"&:hover": {
		background: "linear-gradient(135deg, #4BA3A7 0%, #3A8F92 100%)",
	},
}));

const SignupSuccess: React.FC = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const isStarter = searchParams.get("plan") === "starter";

	return (
		<PageContainer>
			<Card>
				<SignupStepper currentStep="confirmation" />

				<SuccessIconWrap>
					<CheckCircle sx={{ fontSize: 96, color: "#fff" }} />
				</SuccessIconWrap>

				<Typography
					variant="h4"
					sx={{
						fontWeight: 700,
						color: "#1a1a1a",
						mb: 8,
						fontSize: { xs: "24px", md: "28px" },
					}}
				>
					{isStarter ? "Welcome to Arteh!" : "Payment Successful!"}
				</Typography>

				<Box sx={{ width: "100%", maxWidth: 480, px: 3 }}>
					<PrimaryButton onClick={() => navigate("/dashboard")}>
						Access Platform
					</PrimaryButton>
				</Box>
			</Card>
		</PageContainer>
	);
};

export default SignupSuccess;
